module.exports = __webpack_public_path__ + "img/iriomote_2.da7f3810.jpg";